import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, money, dateShort } from "../lib/api";

const STATUS_STYLES = {
  activo: "bg-[#C89B3C]/15 text-[#C89B3C]",
  completado: "bg-emerald-500/15 text-emerald-300",
  cancelado: "bg-red-500/15 text-red-300",
};

export default function Layaways() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => {
    const qs = filter ? `?status_filter=${filter}` : "";
    api(`/admin/layaways${qs}`)
      .then(setItems)
      .catch((e) => toast.error(e.message));
  };
  useEffect(() => {
    load();
     
  }, [filter]);

  return (
    <div data-testid="layaways-view" className="space-y-8">
      <div>
        <p className="text-xs uppercase tracking-[0.4em] text-[#A66E38] mb-3">
          Seguimiento
        </p>
        <h1 className="font-serif text-4xl md:text-5xl font-black text-[#F5F0E6]">
          Apartados
        </h1>
      </div>

      <div className="flex gap-2 flex-wrap" data-testid="layaway-filters">
        {[
          ["", "Todos"],
          ["activo", "Activos"],
          ["completado", "Completados"],
          ["cancelado", "Cancelados"],
        ].map(([k, l]) => (
          <button
            key={k || "all"}
            onClick={() => setFilter(k)}
            data-testid={`filter-${k || "all"}`}
            className={`text-xs uppercase tracking-widest py-2 px-4 border transition-colors ${
              filter === k
                ? "border-[#C89B3C] text-[#0A0908] bg-[#C89B3C]"
                : "border-white/10 text-[#B8A99A] hover:border-[#C89B3C]/50"
            }`}
          >
            {l}
          </button>
        ))}
      </div>

      <div className="bg-[#12100E] border border-white/5">
        {items.length === 0 ? (
          <p className="p-8 text-sm text-[#8A7D71]">Sin apartados.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-widest text-[#8A7D71] border-b border-white/5">
                <th className="py-3 px-4">Folio</th>
                <th className="py-3 px-4">Estado</th>
                <th className="py-3 px-4">Total</th>
                <th className="py-3 px-4">Pagado</th>
                <th className="py-3 px-4">Restante</th>
                <th className="py-3 px-4">Alta</th>
              </tr>
            </thead>
            <tbody>
              {items.map((l) => {
                const remaining = l.total_amount - l.paid_amount;
                return (
                  <tr
                    key={l.id}
                    data-testid={`layaway-row-${l.id}`}
                    className="border-b border-white/5 hover:bg-white/5"
                  >
                    <td className="py-3 px-4">
                      <Link
                        to={`/admin/layaways/${l.id}`}
                        className="text-[#F5F0E6] hover:text-[#C89B3C]"
                      >
                        {l.invoice_number}
                      </Link>
                    </td>
                    <td className="py-3 px-4">
                      <span
                        className={`text-[0.65rem] uppercase tracking-widest px-2 py-1 ${
                          STATUS_STYLES[l.status] || ""
                        }`}
                      >
                        {l.status}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-[#F5F0E6]">
                      {money(l.total_amount)}
                    </td>
                    <td className="py-3 px-4 text-emerald-300">
                      {money(l.paid_amount)}
                    </td>
                    <td className="py-3 px-4 text-amber-300">
                      {money(remaining)}
                    </td>
                    <td className="py-3 px-4 text-[#8A7D71]">
                      {dateShort(l.created_at)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
